class Create_Group {
    static path = 'group-actions/create-group';

    constructor(mutator){
        this.title = 'Create New Group';
        this.addInput("Determining Condition", "boolean");
        this.addInput("Manager", "user,user_id");
        this.addInput("Title", "string");
        this.addOutput("Group", "model,group");

        this.bgcolor = '#dea059';
        this.desc = 'Create a new group';
    }

}

module.exports = Create_Group
